<template>
  <div class="app mx-auto relative h-full desktop">
    <Nav ref="nav"></Nav>
    <main ref="main" class="main relative clearfix h-full overflow-x-hidden">
      <router-view></router-view>
      <BackTop :bottom="348" :right="12" class="text-center">
        <Icon type="md-arrow-up" class="block" />
        <div>返回顶部</div>
      </BackTop>
    </main>
    <FooterBar ref="footer"></FooterBar>
  </div>
</template>
<script>
import Nav from '@/components/common/Nav'
import FooterBar from '@/components/common/FooterBar'

export default {
  name: 'app',
  components: {
    Nav,
    FooterBar
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.main {
  min-height: calc(100vh - 304px); //64px 12.5vw/240px
}
@media only screen and (min-width: 736px) {
}
@media only screen and (max-width: 735px) {
}
</style>
